import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Input } from 'components';
import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';
import { Auth } from 'services';

class ModalInviteUser extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  handleSubmit(data, onSucess, onError) {

    let clinic = this.props.clinic ?? Auth.getManagedClinic();

    API.post(`/clinics/${clinic.id}/veterinarians`, data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size='small'>
          <Header icon="add" content="Inviter un utilisateur" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Name */}
              <Form.Field>
                <label htmlFor="inputMacAddress" className="required">Adresse e-mail</label>
                <Input id="inputMacAddress" name="email" placeholder="" />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalInviteUser.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ModalInviteUser;
